import { Image, ImageProps } from "antd";

interface CustomImageType extends ImageProps {}

const CustomImage = ({ ...rest }: CustomImageType) => {
  return <Image preview={false} {...rest} />;
};

export default CustomImage;
